import { GoogleMaterialIcon } from '../../../ui/GoogleMaterialIcon';
import React, { useEffect, useState, useContext, Fragment } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import MuiButton from "@mui/material/Button";
import { Tooltip } from "@mui/material";
import ClientFilingMasterContext from "../../../../context/client-filing-master/ClientFilingMasterContext";
import AuthContext from "../../../../context/auth/AuthContext";
import {
  downloadCalendarFilingReferenceDocument,
  fetchCalendarFilingReferenceDocument,
} from "./helper";
import { useCommonDetailsContext } from "../../../../context/Common/common";
import { tokens } from '../../../../theme/tokens'; 

const CalendarDetailsReferenceDocuments = () => {
  const { publishedBranding, clientScopedBranding, validateParentData } = useCommonDetailsContext();
  const activeBranding = validateParentData?.isSingleParent ? publishedBranding : (clientScopedBranding || publishedBranding);
  const primaryColor = activeBranding?.primaryColor || tokens.colors.connectedPurple;
  const [referenceDocumentList, setReferenceDocumentList] = useState([]);

  const authContext = useContext(AuthContext);
  const { userRoles, toLocalDateTime } = authContext;
  const clientFilingMasterContext = useContext(ClientFilingMasterContext);
  const { selectedTrackerCalendarEvent, selectedTrackerCalendarEventDisplay } = clientFilingMasterContext;
  const [expanded, setExpanded] = useState(false);

  const handleChange = () => {
    setExpanded((prev) => !prev);
  };

  const getFilename = function (str) {
    return str ? str.replace(/^.*[\\\/]/, "") : "";
  };

  const getUserName = (userId) => {
    const user = userRoles
      ? userRoles?.filter((user) => user.userId === parseInt(userId))[0]
        ?.userName
      : "";
    return user;
  };

  const renderAttachment = (rowData) => {
    // console.log("renderAttachment", rowData);
    return (
      <MuiButton
        size="small"
        variant="text"
        style={{ fontSize: "0.8rem" }}
        onClick={() =>
          downloadFile(rowData.attachmentPath, rowData.attachmentId)
        }
      >
        <Tooltip title={getFilename(rowData.attachmentPath)}>
          {rowData.attachmentPath && getFilename(rowData.attachmentPath)}
        </Tooltip>
      </MuiButton>
    );
  };

  const downloadFile = async (attachmentPath, attachmentId) => {
    const fileName = getFilename(attachmentPath);
    const { filingId } = selectedTrackerCalendarEventDisplay._def.extendedProps;
    await downloadCalendarFilingReferenceDocument(
      attachmentId,
      filingId,
      fileName
    );
  };

  const fetchCalendarEventReferenceDocument = async () => {
    const { filingId } = selectedTrackerCalendarEventDisplay._def.extendedProps;
    try {
      const res = await fetchCalendarFilingReferenceDocument(filingId);
      console.log("fetchCalendarEventReferenceDocument res", res);
      setReferenceDocumentList(res);
    } catch (err) {
      console.log("fetchCalendarEventReferenceDocument err", err);
    }
  };

  useEffect(() => {
    fetchCalendarEventReferenceDocument();
  }, []);

  return (
    <Fragment>
      <Accordion
        disableGutters
        elevation={0}
        square
        onChange={handleChange}
        sx={{
          borderRadius: "12px",
          overflow: "hidden",

          border: "none", // ❌ remove full border
          borderBottom: "1px solid #e0e0e0", // ✅ only bottom border

          "&:before": {
            display: "none", // remove default MUI divider
          },
        }}>
        <AccordionSummary
          expandIcon={
            <div
              style={{
                width: 32,
                height: 32,
                borderRadius: "50%",
                backgroundColor: primaryColor,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#fff",
                fontSize: "18px",
              }}
            >
              {expanded ? "−" : "+"}
            </div>
          }
          sx={{
            backgroundColor: "#f5f6fa",
            minHeight: "56px",
            padding: "0 16px",
            "& .MuiAccordionSummary-content": {
              margin: 0,
            },
          }}
        >
          <Typography
            style={{
              fontSize: "0.9rem",
              fontWeight: "bold",
            }}
          >
            Reference Documents
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <DataTable
            size="small"
            scrollable
            scrollHeight="200px"
            value={referenceDocumentList}
            dataKey="attachmentId"
            style={{ fontSize: "0.8rem" }}
          >
            <Column
              field="createUser"
              header="Created By"
              body={(rowData) => getUserName(rowData.createUser)}
            ></Column>
            <Column
              field="createDate"
              header="Created Date"
              body={(rowData) =>
                toLocalDateTime && toLocalDateTime(rowData.createDate)
              }
            ></Column>
            <Column
              field="attachmentPath"
              header="Attachment"
              body={renderAttachment}
            ></Column>
          </DataTable>
        </AccordionDetails>
      </Accordion>
    </Fragment>
  );
};

export default CalendarDetailsReferenceDocuments;
